import { api } from "../../api";
import { USER_ENDPOINTS } from "../../../constants/endpoints";

export const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: ({
        page = 1,
        pageSize = 50,
        searchTerm = "",
        networkId = "",
        sortBy = "",
        sortOrder = "",
      } = {}) => {
        const params = new URLSearchParams({
          page: String(page),
          pageSize: String(pageSize),
        });

        const searchValue = String(searchTerm || "").trim();
        if (searchValue) {
          params.set("search", searchValue);
          params.set("query", searchValue);
          params.set("displayName", searchValue);
          params.set("dislayName", searchValue);
        }

        if (networkId) {
          params.set("networkId", String(networkId));
        }

        if (sortBy) {
          params.set("sortBy", String(sortBy));
          params.set("sortField", String(sortBy));
        }

        if (sortOrder) {
          const normalizedOrder =
            String(sortOrder).toLowerCase() === "desc" ? "desc" : "asc";
          params.set("sortOrder", normalizedOrder);
          params.set("order", normalizedOrder);
        }

        return {
          url: USER_ENDPOINTS.GET_ALL,
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: params.toString(),
        };
      },
      providesTags: ["User"],
    }),
    updateUserNetwork: builder.mutation({
      query: ({ userId, networkId }) => ({
        url: USER_ENDPOINTS.UPDATE_NETWORK,
        method: "POST",
        body: { userId, networkId },
      }),
      invalidatesTags: ["User"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetAllUsersQuery, useUpdateUserNetworkMutation } = userApi;
